module.exports = __webpack_public_path__ + "static/Eliza3-d1f1752ecd77f7fc026c49e82ee66f3f.png";